import React from "react"

function InputWrapper(props){
    const {labelColor, label} = props;
        return(
            <div className="dx-field">
            <label style={{color: labelColor || "inherit"}}>{label}</label> 
                <div style={{width:"100%"}} className="dx-field-value">
                    {props.children}
                </div>
        </div>
        )
}


export {InputWrapper}